import * as THREE from 'three';
import { RepeatWrapping } from "three";

import { const_var, params } from '../redux/reducers/reducer';
import { wallNameArrForValid } from './Validation';

export const extrudeSettings = (depth, bevelThickness, bevelSize, bevelOffset, bevelSegments) => {
    const setting = {
        steps: 1,
        depth: depth,
        bevelEnabled: true,
        bevelThickness: bevelThickness ?? 0,
        bevelSize: bevelSize ?? 0,
        bevelOffset: bevelOffset ?? 0,
        bevelSegments: bevelSegments ?? 1
    }
    
    return setting;
}
export const textureAnisotropy = (gl, texture, repeatX, repeatY, rotate) => {
    if(texture != "" && texture!=undefined){
    texture.anisotropy = Math.min(gl.capabilities.getMaxAnisotropy(), 50);
    texture.wrapS = texture.wrapT = RepeatWrapping;
    texture.rotation = rotate ? rotate : 0;
    texture.repeat.set(repeatX, repeatY)
    }
}
export const railModel = (width, height) => {
    
    const model = new THREE.Shape();
    model.moveTo(-width / 2, -height / 2);
    model.lineTo(-width / 2, height / 2);
    model.lineTo(width / 2, height / 2);
    model.lineTo(width / 2, -height / 2);
    model.closePath();

    return model;
}
export const wainscotModel = (width, height) => {

    const model = new THREE.Shape();
    model.moveTo(-width / 2 + 0.01, 0 );
    model.lineTo(-width / 2 + 0.01, height);
    model.lineTo(width / 2 - 0.01, height);
    model.lineTo(width / 2 - 0.01, 0 );
    model.closePath();

    return model;
}
export const wainscotTrimModel = (width, height) => {

    const model = new THREE.Shape();
    model.moveTo(width / 2 , -height + 0.03 );
    model.lineTo(width / 2 , - 0.04);
    model.lineTo(width / 2 - 0.005 , - 0.015);
    model.lineTo(0  , 0);
    model.lineTo(0  , -height + 0 );
    model.closePath();

    return model;
}
export const jTrimModel = (width, height) => {

    const jTrimThickness = 0.01
    
    const model = new THREE.Shape();
    model.moveTo(-0.07 / 2, height / 2);
    model.lineTo(-0.07 / 2, -height / 2 -jTrimThickness);
    model.lineTo(width / 2, -height / 2 -jTrimThickness);
    model.lineTo(width / 2, 0);
    model.lineTo(width / 2 - jTrimThickness, 0);
    model.lineTo(width / 2 - jTrimThickness, -height / 2);
    model.lineTo(-0.07 / 2 + jTrimThickness, -height / 2);
    model.lineTo(-0.07 / 2 + jTrimThickness, height / 2);
    model.closePath();

    return model;
}
export const railLoftModel = (widthArea, heightArea, thickness, pitch) => {
    
    const model = new THREE.Shape();
    model.moveTo(-thickness / 2, 0);
    model.lineTo(thickness / 2, 0);
    model.lineTo(thickness / 2, heightArea / 2);
    model.lineTo(thickness / 2 - 0.03, heightArea / 2 + heightArea * 1 / 6);
    model.lineTo(0, heightArea / 2 + heightArea * 2 / 6 + 0.02 + (pitch - 2) / 80); ///
    model.lineTo(-(widthArea - thickness / 2) * 1 / 3 - thickness / 2, heightArea + 0.02 + (pitch - 2) / 60); //
    model.lineTo(-widthArea - thickness / 4, heightArea - thickness + 0.05 + (pitch - 2) / 40); //
    model.lineTo(-(widthArea - thickness / 2) * 1 / 3 - thickness / 2, heightArea / 2 + heightArea * 1 / 6 - thickness / 2 + 0.03 + (pitch - 2) / 80); ///
    model.lineTo(-thickness / 2, heightArea / 2 - thickness / 2 + 0.03);
    model.closePath();

    return model;
}
export const roofBaseRailModel = () => {
    const model = new THREE.Shape();
    model.moveTo(-0.095, 0.04);
    model.lineTo(0.095, 0.04);
    model.lineTo(0.16, -0.02);
    model.lineTo(0.24, -0.02);
    model.lineTo(0.24, -0.025);
    model.lineTo(0.155, -0.025);
    model.lineTo(0.09, 0.035);
    model.lineTo(-0.09, 0.035);
    model.lineTo(-0.155, -0.025);
    model.lineTo(-0.24, -0.025);
    model.lineTo(-0.24, -0.02);
    model.lineTo(-0.16, -0.02);

    return model;
}
export const roofCutShape = () => {
    const model = new THREE.Shape();
    model.moveTo(-2, 1);
    model.lineTo(0, 1);
    model.lineTo(0, -1);
    model.lineTo(-2, -1);
    model.closePath()

    return model;
}

export const getWallDirOnCanvas = ( wallName ) => {
    let direction;
    if (wallName === 'c_b_f_w' || wallName === 'F_L_F_W' || wallName === 'L_L_F_S_W' || wallName === 'R_L_F_S_W' || wallName === 'L_L_F_W' || wallName === 'R_L_F_W' || wallName === 'c_b_f_s_w' || wallName === 'B_L_L_S_W') {
        direction = 'front'
    } else  if (wallName === 'c_b_l_w' || wallName === 'F_L_L_W' || wallName === 'B_L_B_W' || wallName === 'c_b_r_s_l_w' || wallName === 'L_L_F_W' || wallName === 'R_L_R_S_W' || wallName === 'R_L_L_S_W') {
        direction = 'left'
    } else if (wallName === 'c_b_r_w' || wallName === 'R_L_R_W' || wallName === 'B_L_F_W' || wallName === 'F_L_R_W' || wallName === 'F_L_F_S_W' || wallName === 'B_L_F_S_W' || wallName === 'c_b_l_s_r_w' || wallName === 'L_L_L_S_W' || wallName === 'L_L_R_S_W') {
        direction = 'right'
    } else  if (wallName === 'c_b_b_w' || wallName === 'B_L_S_W' || wallName === 'L_L_B_W' || wallName === 'R_L_B_W' || wallName === 'F_L_R_S_W') {
        direction = 'back'
    } 

    return direction;
}

export const delModel = (direction, section) => {
    const wallNameArr = {
        // center building part
        front: ['c_b_f_w', 'c_b_l_s_f_w', 'c_b_r_s_f_w', 'F_L_B_S_W'],
        back: ['c_b_b_w', 'c_b_l_s_b_w', 'c_b_r_s_b_w', 'B_L_B_S_W'],
        left: ['c_b_l_w', 'c_b_l_s_w', 'L_L_R_S_W', 'c_b_f_s_l_w'],
        right: ['c_b_r_w', 'c_b_r_s_w', 'R_L_L_S_W', 'c_b_f_s_r_w'],
        frontStorageFront: ['c_b_f_s_b_w'],
        backStorageFront: ['c_b_f_s_w'],
        backStorageRight: ['c_b_r_w', 'c_b_r_s_w', 'R_L_L_S_W', 'c_b_f_s_r_w'],
        backStorageLeft: ['c_b_l_w', 'c_b_l_s_w', 'L_L_R_S_W', 'c_b_f_s_l_w'],
        leftStorageFront: ['c_b_l_s_r_w'],
        rightStorageFront: ['c_b_r_s_l_w'],

        // front-lean
        frontLeanFront: ['F_L_R_W'],
        frontLeanSide: ['F_L_F_W', 'F_L_F_S_W'],
        frontLeanBack: ['F_L_L_W'],
        frontLeanStorageFront: ['F_L_R_S_W'],
        frontLeanStorageRight: ['c_b_f_w', 'c_b_l_s_f_w', 'c_b_r_s_f_w', 'F_L_B_S_W'],

        // left-lean
        leftLeanFront: ['L_L_F_W'],
        leftLeanSide: ['L_L_L_W', 'L_L_L_S_W'],
        leftLeanBack: ['L_L_B_W'],
        leftLeanStorageFront: ['L_L_F_S_W'],
        leftLeanStorageRight: ['c_b_l_w', 'c_b_l_s_w', 'L_L_R_S_W', 'c_b_f_s_l_w'],

        // right-lean
        rightLeanFront: ['R_L_F_W'],
        rightLeanSide: ['R_L_R_W', 'R_L_R_S_W'],
        rightLeanBack: ['R_L_B_W'],
        rightLeanStorageFront: ['R_L_F_S_W'],
        rightLeanStorageLeft: ['c_b_r_w', 'c_b_r_s_w', 'R_L_L_S_W', 'c_b_f_s_r_w'],

        // back-lean
        backLeanFront: ['B_L_F_W'],
        backLeanSide: ['B_L_S_W', 'B_L_F_S_W'],
        backLeanBack: ['B_L_B_W'],
        backLeanStorageFront: ['B_L_L_S_W'],
        backLeanStorageRight: ['c_b_b_w', 'c_b_l_s_b_w', 'c_b_r_s_b_w', 'B_L_B_S_W'],
    }

    let directionName = '';
    let wallCloseState = '';
    let offsetValue = 1;

    switch (direction) {
        // center building part
        case 'front':
            directionName = wallNameArr[direction];
            if (section === 'wall') {
                wallCloseState = params.p_f_w;
                if (params.cB_addStorage_check_right || params.cB_addStorage_check_left) wallCloseState = "Closed";
            } else if (section === 'leg') {
                wallCloseState = "Closed";
            }
            if (wallCloseState === 'Open' && params.add_front_lean) wallCloseState = 'Gable'
            offsetValue = 1;
            break;
        case 'back':
            directionName = wallNameArr[direction];
            if (section === 'wall') {
                wallCloseState = params.p_b_w;
                if (params.cB_addStorage_check_right || params.cB_addStorage_check_left) wallCloseState = "Closed";
            } else if (section === 'leg') {
                wallCloseState = "Closed";
            }
            if (wallCloseState === 'Open' && params.add_back_lean) wallCloseState = 'Gable'
            offsetValue = -1;
            break;
        case 'left':
            directionName = wallNameArr[direction];
            if (section === 'wall') {
                wallCloseState = params.p_l_w;
                if (params.p_u_c || params.cB_addStorage_check_left) wallCloseState = "Closed";
            } else if (section === 'leg') {
                wallCloseState = "Closed";
            }
            if (wallCloseState === 'Open' && params.add_left_lean) wallCloseState = 'Gable'
            offsetValue = 1;
            break;
        case 'right':
            directionName = wallNameArr[direction];
            if (section === 'wall') {
                wallCloseState = params.p_r_w;
                if (params.p_u_c || params.cB_addStorage_check_right) wallCloseState = "Closed";
            } else if (section === 'leg') {
                wallCloseState = "Closed";
            }
            if (wallCloseState === 'Open' && params.add_right_lean) wallCloseState = 'Gable'
            offsetValue = -1;
            break;
        case 'frontStorageFront':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = 1;
            break;
        case 'backStorageFront':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = 1;
            break;
        case 'backStorageRight':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = -1;
            break;
        case 'backStorageLeft':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = 1;
            break;
        case 'leftStorageFront':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            if (section === 'wall') {
                offsetValue = 1;  
            } else if(section === 'leg'){
                offsetValue = -1; 
            }
            break;
        case 'rightStorageFront':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            if (section === 'wall') {
                offsetValue = -1;  
            } else if(section === 'leg'){
                offsetValue = 1; 
            }
            break;

        // front-lean
        case 'frontLeanFront':
            directionName = wallNameArr[direction];
            wallCloseState = params.p_b_c_b_f_f;
            offsetValue = 1;
            break;
        case 'frontLeanSide':
            directionName = wallNameArr[direction];
            if (section === 'wall') {
                wallCloseState = params.p_b_c_b_f_l;
                if (params.add_storage_check_front) wallCloseState = "Closed";
            } else if (section === 'leg') {
                wallCloseState = "Closed";
            }
            offsetValue = 1;
            break;
        case 'frontLeanBack':
            directionName = wallNameArr[direction];
            wallCloseState = params.p_b_c_b_f_b;
            wallCloseState = 'Closed';
            offsetValue = -1;
            break;
        case 'frontLeanStorageFront':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = 1;
            break;
        case 'frontLeanStorageRight':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = -1;
            break;

        // left-lean
        case 'leftLeanFront':
            directionName = wallNameArr[direction];
            wallCloseState = params.p_b_c_b_l_f;
            offsetValue = 1;
            break;
        case 'leftLeanSide':
            directionName = wallNameArr[direction];
            if (section === 'wall') {
                wallCloseState = params.p_b_c_b_l;
                if (params.add_storage_check) wallCloseState = "Closed";
            } else if (section === 'leg') {
                wallCloseState = "Closed";
            }
            offsetValue = -1;
            break;
        case 'leftLeanBack':
            directionName = wallNameArr[direction];
            wallCloseState = params.p_b_c_b_l_b;
            offsetValue = -1;
            break;
        case 'leftLeanStorageFront':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = 1;
            break;
        case 'leftLeanStorageRight':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = -1;
            break;

        // right-lean
        case 'rightLeanFront':
            directionName = wallNameArr[direction];
            wallCloseState = params.p_b_c_b_r_f;
            offsetValue = 1;
            break;
        case 'rightLeanSide':
            directionName = wallNameArr[direction];
            if (section === 'wall') {
                wallCloseState = params.p_b_c_b_r;                
                if (params.add_storage_check_right) wallCloseState = "Closed";
            } else if (section === 'leg') {
                wallCloseState = "Closed";
            }

            offsetValue = 1;
            break;
        case 'rightLeanBack':
            directionName = wallNameArr[direction];
            wallCloseState = params.p_b_c_b_r_b;
            offsetValue = -1;
            break;
        case 'rightLeanStorageFront':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = 1;
            break;
        case 'rightLeanStorageLeft':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = 1;
            break;

        // back-lean
        case 'backLeanFront':
            directionName = wallNameArr[direction];
            wallCloseState = params.p_b_c_b_b_f;
            offsetValue = 1;
            break;
        case 'backLeanSide':
            directionName = wallNameArr[direction];
            if (section === 'wall') {
                wallCloseState = params.p_b_c_b_b_l;
                if (params.add_storage_check_back) wallCloseState = "Closed";
            } else if (section === 'leg') {
                wallCloseState = "Closed";
            }
            offsetValue = -1;
            break;
        case 'backLeanBack':
            directionName = wallNameArr[direction];
            wallCloseState = params.p_b_c_b_b_b;
            offsetValue = -1;
            break;
        case 'backLeanStorageFront':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = 1;
            break;
        case 'backLeanStorageRight':
            directionName = wallNameArr[direction];
            wallCloseState = 'Closed';
            offsetValue = 1;
            break;
        default:
    }

    let modelGroup = [];
    const offsetValue_Temp = offsetValue;
    const_var.newDoorsArray.filter((item) => directionName.includes(item.userData.wallName)).map((item) => {
        const width = item.width;
        const height = item.height;
        const pos_x = item.positionX;
        const pos_y = item.positionY;

        if (item.userData.wallName === 'R_L_L_S_W' || item.userData.wallName === 'L_L_R_S_W') {
            offsetValue = offsetValue_Temp * -1;
        } else {
            offsetValue = offsetValue_Temp;
        }


        if (item.userData.compType === "garage_door" ||
            item.userData.compType === "garage_door_frameout" ||
            item.userData.compType === "walkin" ||
            item.userData.compType === "walkin_frameout"
        ) {
            if (!(item.userData.compType.includes('frameout') && wallCloseState === 'Open')) {
                let trimOffset;
                if(width >= 2.5){
                    trimOffset = 1
                } else {
                    trimOffset = width / 3
                }
                const model = new THREE.Shape();
                if(item.userData.compName === "standard_trim_door"){
                    model.moveTo(pos_x * offsetValue - width / 2, 0);
                    model.lineTo(pos_x * offsetValue - width / 2, height - trimOffset);
                    model.lineTo(pos_x * offsetValue - width / 2 + trimOffset, height);
                    model.lineTo(pos_x * offsetValue + width / 2 - trimOffset, height);
                    model.lineTo(pos_x * offsetValue + width / 2, height - trimOffset);
                    model.lineTo(pos_x * offsetValue + width / 2, 0);
                    model.closePath();
                } else if(item.userData.compName === "double_slider_door_door"){
                   return null;
                } else {
                    model.moveTo(pos_x * offsetValue - width / 2, 0);
                    model.lineTo(pos_x * offsetValue - width / 2, height);
                    model.lineTo(pos_x * offsetValue + width / 2, height);
                    model.lineTo(pos_x * offsetValue + width / 2, 0);
                    model.closePath();
                }

                modelGroup.push(model);
            }
        } else if ((item.userData.compType === "window" || item.userData.compType === "window_frameout") && item.userData.compName != "faux_window_window") {
            if (!(item.userData.compType.includes('frameout') && wallCloseState === 'Open')) {
                const model = new THREE.Shape();
                model.moveTo(pos_x * offsetValue - width / 2, pos_y - height / 2);
                model.lineTo(pos_x * offsetValue - width / 2, pos_y + height / 2);
                model.lineTo(pos_x * offsetValue + width / 2, pos_y + height / 2);
                model.lineTo(pos_x * offsetValue + width / 2, pos_y - height / 2);
                model.closePath();

                modelGroup.push(model);
            }
        }

        return null;
    })

    return modelGroup;
}
export const sortDoorObject = ( sideArray ) =>{
    const sort = sideArray.sort((door1, door2) => {
        return door1["positionX"] - door2["positionX"];
    });
    return sort;
}
export const getMaxHeight = (sideArray) => {
    let maxHeight = -Infinity;

    for (let obj of sideArray) {
        if (obj.hasOwnProperty('height') && typeof obj.height === 'number') {
            if (obj.height > maxHeight) {
                maxHeight = obj.height;
            }
        }
    }

    return maxHeight;
}
export const convertSizeFormat = (size, type) => {

    const parts = size.split('x'); 

    if (parts.length === 2) {
        const width = parts[0]; 
        const height = parts[1]; 
        if(type === 'door') return `${width}'x${height}'`;
        else if(type === 'window' || type === 'walkin') return `${width}"x${height}"`;
    }

    return size;
}

// export const roofPattern = (patternLength,isPattern) => {
//     const step = 0.7336;
//     let i = 0;

//     const model = new THREE.Shape();
//     model.moveTo(0, -0.005);
//     model.lineTo(0, 0);

//     while (i <= patternLength) {
        
//         let islastIteration =false
//         if((!params.p_v_w && (params.wallTexture == "none" || params.wallTexture == undefined)) || isPattern){
//         if (i + 0.015 <= patternLength){ model.lineTo(i + 0.015, 0.045)}
//         if (i + 0.03 <= patternLength){ model.lineTo(i + 0.03, 0.045)}
//         if (i + 0.045 <= patternLength){ model.lineTo(i + 0.045, 0.06)}
//         if (i + 0.06 <= patternLength){ model.lineTo(i + 0.06, 0.06)}
//         if (i + 0.075 <= patternLength){ model.lineTo(i + 0.075, 0.06)}
//         if (i + 0.09 <= patternLength){ model.lineTo(i + 0.09, 0.045)}
//         if (i + 0.105 <= patternLength){ model.lineTo(i + 0.105, 0.045)}
//         if (i + 0.12 <= patternLength){ model.lineTo(i + 0.12, 0)}
//         if (i + 0.28 <= patternLength){ model.lineTo(i + 0.28, 0)}
//         if (i + 0.2967 <= patternLength){ model.lineTo(i + 0.2967, 0.018)}
//         if (i + 0.3134 <= patternLength){ model.lineTo(i + 0.3134, 0.018)}
//         if (i + 0.3301 <= patternLength){ model.lineTo(i + 0.3301, 0.018)}
//         if (i + 0.3468 <= patternLength){ model.lineTo(i + 0.3468, 0)}
//         if (i + 0.5068 <= patternLength){ model.lineTo(i + 0.5068, 0)}
//         if (i + 0.5235 <= patternLength){ model.lineTo(i + 0.5235, 0.018)}
//         if (i + 0.5402 <= patternLength){ model.lineTo(i + 0.5402, 0.018)}
//         if (i + 0.5569 <= patternLength){ model.lineTo(i + 0.5569, 0.018)}
//         if (i + 0.5736 <= patternLength){ model.lineTo(i + 0.5736, 0)}
//         if (i + step <= patternLength){ model.lineTo(i + step, 0); islastIteration = true}
//         }
//         if(!islastIteration) {model.lineTo(patternLength, 0);
//             model.lineTo(patternLength, -0.005)
//         }

//         i += step;
//     }

//     model.closePath();

//     return model
// }


const keyPatternIncrements = [
    { x: 0.015, y: 0.045 }, { x: 0.03, y: 0.045 }, { x: 0.045, y: 0.06 },
    { x: 0.06, y: 0.06 }, { x: 0.075, y: 0.06 }, { x: 0.09, y: 0.045 },
    { x: 0.105, y: 0.045 }, { x: 0.12, y: 0 }, { x: 0.28, y: 0 },
    { x: 0.2967, y: 0.018 }, { x: 0.3134, y: 0.018 }, { x: 0.3301, y: 0.018 },
    { x: 0.3468, y: 0 }, { x: 0.5068, y: 0 }, { x: 0.5235, y: 0.018 },
    { x: 0.5402, y: 0.018 }, { x: 0.5569, y: 0.018 }, { x: 0.5736, y: 0 }
  ];
  
  export const roofPattern = (patternLength, isPattern) => {
    const step = 0.7336;
    const points = [];
  
    const shouldSimplify = ((!params.p_v_w || params.wallTexture==undefined || (params.wallTexture !== "none" && params.wallTexture !== "vertical")) && isPattern==undefined) || isPattern==true;
      
    // Add multiple points at once to reduce function overhead
    points.push(
      new THREE.Vector2(0, -0.005),
      new THREE.Vector2(0, 0)
    );
  
    // Cache keyPatternIncrements length for loop optimization
    const keyPatternCount = keyPatternIncrements.length;
  
    // Use a for-loop to reduce overhead compared to a while-loop
    for (let i = 0; i <= patternLength; i += step) {
      const nextStep = i + step;
  
      if (nextStep <= patternLength && shouldSimplify) {
        // Precompute and add all points from increments in one loop
        for (let j = 0; j < keyPatternCount; j++) {
          const { x, y } = keyPatternIncrements[j];
          points.push(new THREE.Vector2(i + x, y));
        }
        points.push(new THREE.Vector2(nextStep, 0));
      } else {
        // Handle case when pattern length is reached
        for (let j = 0; j < keyPatternCount; j++) {
            const { x, y } = keyPatternIncrements[j];
            if (i + x <= patternLength && shouldSimplify) points.push(new THREE.Vector2(i + x, y));
        }
        points.push(
          new THREE.Vector2(patternLength, 0),
          new THREE.Vector2(patternLength, -0.005)
        );
        break;
      }
    }
  
    const model = new THREE.Shape(points);
    model.closePath();
    return model;
  };
export const roofPatternCurve = (sign, pitch) => {
    
    let offset

    if (typeof pitch === 'string') {

        const pitchNumber = Number(pitch);
        
        if (!isNaN(pitchNumber)) {
            offset = 0.1 * (pitchNumber / 12);
        } else {
            offset = 0
        }
    }  else {
        offset = 0
    }

    const model = new THREE.Shape();
    model.moveTo(sign*0, 0);
    model.lineTo(sign*0.03, -0.015);
    model.lineTo(sign*0.065, -0.05);
    model.lineTo(sign*0.09, -0.095);
    model.lineTo(sign*0.135, -0.11);
    model.lineTo(sign*0.135, -0.125);
    model.lineTo(sign*0.15, -0.14);
    model.lineTo(sign*0.15, -0.17);
    model.lineTo(sign*0.135, -0.185);
    model.lineTo(sign*0.135, -0.2);
    model.lineTo(sign*0.1, -0.215);
    model.lineTo(sign*0.1, -0.3332);
    model.lineTo(sign*0.118, -0.3499);
    model.lineTo(sign*0.118, -0.3833);
    model.lineTo(sign*0.1, -0.4 - offset);
    model.lineTo(sign*0.1, -0.42 - offset);
    model.lineTo(sign*0.09, -0.1);
    model.lineTo(sign*0.065, -0.06);
    model.lineTo(sign*0.03, -0.02);
    model.closePath();

    return model;
}

// LADDER Truss bottom rail shape
export const ladderTrussBottomRailModel = (railLength) => {
    const model = new THREE.Shape();
    model.moveTo(0, 0);
    model.lineTo(0, -railLength);
    model.lineTo(-0.1, -railLength - 0.3);
    model.lineTo(-0.25, -railLength - 0.2);
    model.lineTo(-0.2, -railLength);
    model.lineTo(-0.2, railLength);
    model.lineTo(-0.25, railLength + 0.2);
    model.lineTo(-0.1, railLength + 0.3);
    model.lineTo(0, railLength);
    model.closePath()

    return model;
}

// Function to darken a color by a given percentage
export const darkenColor = (hex, percent) => {
    // Parse the hex color
    hex = hex.replace(/^#/, '');
    const r = parseInt(hex.substr(0, 2), 16);
    const g = parseInt(hex.substr(2, 2), 16);
    const b = parseInt(hex.substr(4, 2), 16);

    // Calculate the darker color
    const darkerR = Math.round(r * (100 - percent) / 100);
    const darkerG = Math.round(g * (100 - percent) / 100);
    const darkerB = Math.round(b * (100 - percent) / 100);

    // Convert back to hex
    const darkerHex = '#' + ((1 << 24) + (darkerR << 16) + (darkerG << 8) + darkerB).toString(16).slice(1);

    return darkerHex;
}

export const revertPosOfCmp = (doorsArray, wallName) => {
    doorsArray.forEach(item => {
        const isValidWall = wallNameArrForValid.find(subArray => subArray.includes(wallName)).filter(validWall => validWall !== wallName).includes(item.userData.wallName);
        if (!const_var.isEdit)
        if ((wallName === 'R_L_L_S_W' || wallName === 'L_L_R_S_W') && isValidWall) {
            item.positionX *= -1;
        } else if ((wallName === 'c_b_r_w' || wallName === 'c_b_r_s_w' || wallName === 'c_b_f_s_r_w') && item.userData.wallName === 'R_L_L_S_W') {
            item.positionX *= -1;
        } else if ((wallName === 'c_b_l_w' || wallName === 'c_b_l_s_w' || wallName === 'c_b_f_s_l_w') && item.userData.wallName === 'L_L_R_S_W') {
            item.positionX *= -1;
        }
    });
}